// bookie-teal-preview — bk04 "Lojuvard" preview card.
//
// Quiet, classical bookie invitation card. A double hairline frame in teal
// surrounds an ivory inner card with a small filigree wreath, the couple's
// names in Cormorant Garamond, and a venue line beneath.
import { Photo, type LayoutCtx } from "./_shared";

export function BookieTealPreviewLayout({ names, date, venue, accent, ink, bg, font, photo }: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(180deg, ${bg} 0%, ${accent}10 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      {/* Double hairline frame */}
      <div
        style={{
          flex: 1,
          position: "relative",
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 4px ${bg}, inset 0 0 0 5px ${accent}33`,
        }}
      >
        {/* Eyebrow */}
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TAKLIFNOMA
        </div>

        {/* Cypress wreath crest */}
        <div style={{ width: "60%", aspectRatio: "1 / 1", marginBottom: "5%", position: "relative" }}>
          <Photo
            src={photo}
            style={{ position: "absolute", inset: "10%", borderRadius: "50%" }}
            fallback={
              <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", display: "block" }}>
                <defs>
                  <radialGradient id="tealMedal" cx="50%" cy="45%">
                    <stop offset="0%" stopColor={`${accent}22`} />
                    <stop offset="100%" stopColor={bg} />
                  </radialGradient>
                </defs>
                <circle cx="50" cy="50" r="44" fill="url(#tealMedal)" stroke={accent} strokeWidth="0.6" opacity="0.9" />
                <circle cx="50" cy="50" r="36" fill="none" stroke={accent} strokeWidth="0.4" opacity="0.5" />
                <g fill="none" stroke={accent} strokeWidth="0.7" strokeLinecap="round" opacity="0.85">
                  <path d="M50 16 Q 42 28 50 40 Q 58 28 50 16 Z" />
                  <path d="M50 84 Q 42 72 50 60 Q 58 72 50 84 Z" />
                  <path d="M16 50 Q 28 42 40 50 Q 28 58 16 50 Z" />
                  <path d="M84 50 Q 72 42 60 50 Q 72 58 84 50 Z" />
                </g>
                <g transform="translate(50 50)" fill={accent} opacity="0.9">
                  <circle r="1.8" />
                  {[0, 60, 120, 180, 240, 300].map((d) => (
                    <ellipse key={d} cx="0" cy="-5" rx="1.2" ry="2.6" transform={`rotate(${d})`} />
                  ))}
                </g>
              </svg>
            }
          />
        </div>

        {/* Names */}
        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TAKLIFNOMA · {date}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
